const ITEMS = [
  "Bespoke floral prints",
  "Hand-carved wooden handles",
  "UV-50+ sun shield",
  "One of one — always",
  "Ships in a gift box",
  "Batch Nº 07 out now",
];

const Flower = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 sm:h-5 sm:w-5 shrink-0" aria-hidden="true">
    <path d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9L4.9 19.1" stroke="#E85D04" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-6 pr-6 sm:gap-10 sm:pr-10">
        <span className="whitespace-nowrap font-serif italic text-lg sm:text-2xl text-ink/85">{t}</span>
        <Flower />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="relative z-10" data-testid="marquee-section">
      <div className="-rotate-1 scale-105 overflow-hidden border-y-2 border-ink/10 bg-marigold py-4 sm:py-5">
        <div className="flex w-max animate-marquee" data-testid="marquee">
          <Row />
          <Row hidden />
        </div>
      </div>
    </section>
  );
}
